export const VIGO_MASTER_QUOTATION_VI = {
  title: 'Giá tổng của Vigo',
  vigoMasterNumber: 'Mã báo giá tổng của Vigo',
  all: 'TẤT CẢ',
  request_high_level_approved: 'DUYỆT CẤP ĐỘ 2',
  pending: 'CHỜ XỬ LÝ',
  awaiting_logistics: 'CHỜ VẬN CHUYỂN',
  awaiting_approval: 'CHỜ DUYỆT',
  closed: 'ĐÃ ĐÓNG',
  number: 'Mã báo giá tổng',
  selectSuppliers: 'Chọn Nhà cung cấp',
  contentSelectSuppliers: 'Chọn nhà cung cấp và số lượng đặt hàng',
  arrangeLogistics: 'Sắp xếp vận chuyển',
  contentArrangeLogistics: 'Dành cho Nhà cung cấp không hỗ trợ giao',
  approval: 'Duyệt',
  contentApproval: 'Chiết khấu và Phê duyệt',
  issueQuotation: 'Phát hành báo giá',
  contentIssueQuotation: 'Dành cho đơn mua hàng Nhà phân phối',
  editByBatch: 'Chỉnh sửa theo số lô',
  updateQuantityByBatch: 'Cập nhật số lượng theo số lô',
  viewTermAndCondition: 'Xem Điều khoản và Điều kiện',
  withShip: 'With Ship',
  withoutShip: 'Without Ship',
  competitorPrice: 'Giá cạnh tranh',
  maxQuantitySuggest: 'Số lượng gợi ý tối đa:',
  soldQuantity: 'Đã bán:',
  currentInventory: 'Tồn kho hiện tại:',
  estimateStockPerDay: 'Dự đoán tồn mỗi ngày:',
  payToSupplier: 'Thanh toán cho Nhà cung cấp',
  contentPayment: 'Thanh toán cho Nhà cung cấp trước khi nhận hàng?',
  supplierName: 'Nhà cung cấp',
  pay_after_delivery: 'Sau khi giao hàng',
  pay_before_delivery: 'Trước khi giao hàng',
  pendingRouter: 'Tuyến giao đang chờ xử lý',
  sort: 'Xếp',
  fromSupplier: 'Từ Nhà cung cấp',
  toDistributor: 'Đến Nhà phân phối',
  estimateWeight: 'Khối lượng ước tính (kg)',
  deliveryPartner: 'Đối tác giao hàng',
  deliveryGroup: 'Nhóm giao hàng',
  confirmArrange: 'Xác nhận & Tiếp tục',
  distributor_pickup: 'Nhà phân phối giao',
  newVigoDelivery: 'Tóm tắt giao hàng mới của Vigo',
  noOfRoute: 'Số tuyến đường',
  estimateCost: 'Chi phí ước tính',
  pricePerTon: 'Giá/Tấn',
  deliveryDiscount: 'Chiết khấu giao hàng',
  confirmDeadline: 'Xác nhận thời gian',
  suggestedDeliveryGroup: 'Nhóm giao hàng được đề xuất ',
  estCost: 'Chi phí ước tính',
  totalDelivery: 'Tổng giao',
  purchasedPrice: 'Giá đã mua',
  bidding: 'ĐẤU THẦU',
  pricing: 'MÔ HÌNH ĐỊNH GIÁ',
  retail: 'Bán lẻ',
  trading: 'Thương mại',
  consignment: 'Ký gửi',
  errorSelect: 'Vui lòng chọn Nhà cung cấp cho tất cả SKUs!',
  qty: 'Tổng số lượng Thùng',
  firstMile: 'Chi phí vận chuyển',
  cogs: 'Giá nhập từ NCC',
  marketSurveyPurchasePrice: 'Giá nhập khảo sát thị trường',
  applyMarginStandard: 'Lợi nhuận tiêu chuẩn',
  adjustmentSellingPriceOnApp: 'Điều chỉnh giá bán trên ứng dụng',
  adjustmentSACommission: 'Điều chỉnh hoa hồng CTV',
  adjustmentPriceWithDistributor: 'Điều chỉnh giá mua/bán với Nhà phân phối',
  marginAfterCorrection: 'Lợi nhuận sau điều chỉnh',
  estimatedReferenceSellingPriceOnApp:
    'Giá bán tham khảo dự kiến trên ứng dụng',
  marketSurveyPriceMin: 'Giá khảo sát thị trường - tối thiểu',
  marketSurveyPriceMax: 'Giá khảo sát thị trường - tối đa',
  distributorSupportPrice: 'Nhà phân phối hỗ trợ',
  referenceSellingPriceOnAppFinal: 'Giá bán tham khảo trên ứng dụng final',
  distributorTC: 'T&C nhà phân phối',
  sACommission: 'Hoa hồng CTV',
  sACommissionFinal: 'Hoa hồng CTV final',
  vigoBudget: 'Ngân sách Vigo',
  percentCM3Expected: '%CM3 Dự kiến',
  cM3Expected: 'CM3 Dự kiến',
  vigoMissionFeeProvisionallyCollected: 'Phí nhiệm vụ CTV Vigo tạm thu',
  vigoMissionFeeProvisionallyCollectedFinal:
    'Phí nhiệm vụ CTV Vigo tạm thu final',
  surveyAmplitude: 'Biên độ khảo sát',
  surveyAmplitudeFinal: 'Biên độ khảo sát final',
  vigoPurchasePriceSurvey: 'Giá nhập Vigo khảo sát',
  vigoPurchasePriceSurveyFinal: 'Giá nhập Vigo khảo sát final',
  surveySellingPriceToDistributor: 'Giá bán khảo sát cho NPP',
  surveySellingPriceToDistributorFinal: 'Giá bán khảo sát cho NPP final',
  markupPrice: 'Markup price',
  controlTypeOfMarkupPrice: 'Loại markup price',
  specialSubsidyOnCase: 'Trợ giá NPP',
  specialTCDistributorOnCase: 'T&C NPP đặc biệt',
  purchasePriceVigoAcceptToBuy: 'Giá vốn Vigo chấp nhận mua hàng',
  surveyPriceDifference: 'Chênh lệch giá khảo sát',
  referenceSellingPriceForDistributor: 'Giá bán tham khảo cho NPP',
  priceVigoAgreesToSellToDistributor: 'Giá Vigo đồng ý bán cho NPP',
  minimumRecommendedPriceOnApp:
    'Trading: Giá bán khảo sát Retail DPO,Retail SDPO, Consignment: Giá App khuyến nghị tối thiểu (theo khảo sát)',
  maximumRecommendedPriceOnApp:
    'Trading:Giá bán niêm yết Retail DPO,Retail SDPO, Consignment: Giá app khuyến nghị tối đa (theo khảo sát)',
  totalSACommission: 'Tổng hoa hồng CTV',
  verifyCM3: 'CM3',
  percentCM3: '%CM3',
  interactiveMission: 'Nhiệm vụ CTV tương tác',
  weeklyBonus: 'Thưởng CTV hàng tuần',
  estimatedDistributorBudget: 'Ước tính ngân sách NPP',
  verifyCM3WithoutVAT: 'CM3 không bao gồm VAT',
  percentCM3WithoutVAT: '%CM3 không bao gồm VAT',
  percentCM1WithoutVAT: '%CM1 không bao gồm VAT',
  percentCM2WithoutVAT: '%CM2 không bao gồm VAT',
  deposit: 'Tiền đặt cọc',
  specialSASubsidyOnCase: 'Trợ giá đặc biệt / Thùng',
  finalBaseMargin: 'Lợi nhuận cơ bản cuối cùng',
  specialCommissionType: 'Loại hoa hồng đặc biệt',
  supplierCode: 'Nhà cung cấp',
  supplier_delivery: 'Nhà cung cấp giao',
  titleCode37Trading: 'Giá bán khảo sát',
  titleCode37RetailAndConsignment:
    'Giá App khuyến nghị tối thiểu (theo khảo sát)',
  titleCode38Trading: 'Giá bán niêm yết',
  titleCode38RetailAndConsignment: 'Giá App khuyến nghị tối đa (theo khảo sát)',
  informationSave:
    'Dữ liệu chưa được lưu. Những thay đổi chỉ mang tính tạm thời để tính toán lại mô hình định giá và chỉ được lưu khi nhấp vào nút Xác nhận.',
  extraCommissionTypeAffiliate: 'Extra Commission Value Affiliate',
  extraCommissionTypeInHouse: 'Extra Commission Value In-House',
  extraCommissionTypeWholesaleAgent: 'Extra Commission Value Wholesale Agent',
  extraCommissionTypeDistributorAgent:
    'Extra Commission Value Distributor Agent',
  extraCommissionTypeBGM: 'Extra Commission Value BGM',
}
